import { useTheme } from '../../hooks/useTheme.js';

var buildStyle = function (_a) {
    var breakPoints = _a.breakPoints, minIdx = _a.minIdx, maxIdx = _a.maxIdx, match = _a.match, notMatch = _a.notMatch;
    var value = [];
    for (var index in breakPoints) {
        if (Object.prototype.hasOwnProperty.call(breakPoints, index)) {
            var idx = parseInt(index);
            value.push(idx >= (minIdx !== null && minIdx !== void 0 ? minIdx : idx) && idx <= (maxIdx !== null && maxIdx !== void 0 ? maxIdx : idx) ? match : notMatch);
            if (idx === (minIdx !== null && minIdx !== void 0 ? minIdx : maxIdx)) {
                if (maxIdx !== undefined) {
                    value.push(notMatch);
                }
                return value;
            }
        }
    }
};
var useResponsiveCss = function (_a) {
    var _b;
    var _c, _d;
    var cssProp = _a.cssProp, _e = _a.match, match = _e === void 0 ? "visible" : _e, _f = _a.notMatch, notMatch = _f === void 0 ? "hidden" : _f, min = _a.min, max = _a.max, _g = _a.sx, sxProp = _g === void 0 ? {} : _g, useDisplay = _a.useDisplay;
    var _h = useTheme(), mergeStyles = _h.mergeStyles, theme = _h.theme;
    if (!min && !max)
        return sxProp;
    var resolvedCssProp = cssProp || (useDisplay ? "display" : "visibility");
    var resolvedMatch = useDisplay && match === "visible" ? "block" : match;
    var resolvedNotMatch = useDisplay && notMatch === "hidden" ? "none" : notMatch;
    var rSx = (_b = {},
        _b[resolvedCssProp] = buildStyle({
            breakPoints: theme.breakpoints,
            minIdx: min ? (_c = theme.namedBreakpointIndexes) === null || _c === void 0 ? void 0 : _c[min] : undefined,
            maxIdx: max ? (_d = theme.namedBreakpointIndexes) === null || _d === void 0 ? void 0 : _d[max] : undefined,
            match: resolvedMatch,
            notMatch: resolvedNotMatch,
        }),
        _b);
    return mergeStyles([sxProp, rSx]);
};

export { useResponsiveCss };
//# sourceMappingURL=useResponsiveCss.js.map
